/* istanbul ignore file */
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { CallbackComponent } from './components/callback/callback.component';
import { NotificationHomeComponent } from '../app/components/notification-home/notification-home.component';
import { NotificationPreferenceComponent } from '../app/components/notification-preference/notification-preference.component'
import { NgModule } from '@angular/core';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';

const routes: Routes = [
  { path: 'callback', component: CallbackComponent },
  { path: 'login', redirectTo: 'notification' },
  { path: '', redirectTo: 'notification', pathMatch: 'full' },
  {
    path: 'notification', component: NotificationHomeComponent, canActivate: [authGuard],
    children: [{ path: ':id/preference', component: NotificationPreferenceComponent, canDeactivate:[CanDeactivateGuard]}]
  },
  {
    path: '**', redirectTo: 'notification', pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
